import { render, staticRenderFns } from "./BaseRequiredDropdown.vue?vue&type=template&id=c0326010"
import script from "./BaseRequiredDropdown.vue?vue&type=script&lang=js"
export * from "./BaseRequiredDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports